let drawerExpanded = false;

let drawerToggle = () => {
  let drawer = document.querySelector("#drawer")! as HTMLElement;

  if (drawerExpanded) {
    drawer.style.right = "-" + drawer.clientWidth + "px";
    // drawer.className += "hidden";
  } else {
    drawer.style.right = "0px";
    // drawer.className.replace("hidden", "");
  }
  drawerExpanded = !drawerExpanded;
};

export { drawerToggle };
